<template>
  <div class="operation-dialog">
    <md-popup
      v-model="dialogVisible"
      @hide="hideDialog"
    >
      <div class="icon">
        <img src="@/assets/image/icons/icon-warning.svg">
      </div>
      <div class="text">
        {{ dialogTitle }}
      </div>
      <div class="button">
        <md-button type="primary" round @click="goBindBank">
          {{ $t('doItNow') }}
        </md-button>
      </div>
      <div class="button">
        <md-button type="primary" plain round @click="hideDialog">
          {{ $t('later') }}
        </md-button>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Popup } from 'mand-mobile'

import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        title: 'For your account security, please bind your bank account',
        doItNow: 'Do it now',
        later: 'Later',
      },
      id: {
        title: 'Demi keamanan akun Anda, harap sambungkan akun bank Anda',
        doItNow: 'Lakukan sekarang',
        later: 'Nanti',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  mixins: [dialogMixins],
  computed: {
    dialogTitle() {
      return this.title ? this.title : this.$t('title')
    },
  },
  methods: {
    goBindBank() {
      this.hideDialog()
      this.$router.push({ name: 'UserSecurity' })
    },
  },
}
</script>

<style scoped lang="stylus">
.operation-dialog /deep/ {
  .md-popup-box {
    width: 90%;
    padding: 60px 30px 30px;
    background-color: #fff;
    border-radius: 6px;
  }
  .icon {
    text-align: center;
    margin-bottom: 25px;
    img {
      width: 46px;
      height: 46px;
    }
  }
  .text {
    text-align: center;
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 1.25em;
    font-weight: bold;
  }
  .button .md-button {
    margin-bottom: 15px;
    border-radius: 20px;
  }
}
</style>
